import { render } from "./Employee_Appraisals.vue?vue&type=template&id=0fcd5fef&scoped=true"
import script from "./Employee_Appraisals.vue?vue&type=script&lang=js"
export * from "./Employee_Appraisals.vue?vue&type=script&lang=js"

import "./Employee_Appraisals.vue?vue&type=style&index=0&id=0fcd5fef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcd5fef"]])

export default __exports__